import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  ButtonContainer,
  Content,
  InvertedButton,
  Modal,
} from './styles';

const RescheduleModal = (props) => {
  const {
    content,
    loading,
    onClose,
    onSubmit,
    open,
  } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Content>
        {content}
      </Content>

      <ButtonContainer>
        <InvertedButton loading={loading} onClick={() => onSubmit(false)}>
          Never mind, don&apos;t reschedule
        </InvertedButton>

        <Button
          loading={loading}
          disabled={loading}
          onClick={() => onSubmit(true)}
        >
          Yes, reschedule
        </Button>
      </ButtonContainer>
    </Modal>
  );
};

RescheduleModal.propTypes = {
  content: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default RescheduleModal;
